module.exports = __webpack_public_path__ + "img/scop2.200f449f.jpg";